import { useEffect, useState } from "react";

import useActionCreator from "@redux/hooks/useActionCreator";

import { TenderNoticePublicationType } from "@type/procurements/createProcurement/tenderNoticePublication";

import { TenderNoticePublicationState } from "@reducers/types/procurements/create-procurements/tender-notice-publication-state";
import useCustomSelector from "@redux/hooks/useCustomSelector";

interface UseTenderNoticePublication {
  TNPData: TenderNoticePublicationState;
  createTenderNoticePublication: (
    data: TenderNoticePublicationType,
    id: string | number,
    tenderNoticePublicationId: string | number,
  ) => void;
}

export const useTenderNoticePublication = (
  id: string | number,
): UseTenderNoticePublication => {
  const { createTenderNoticePublication, fetchTNPDetails } = useActionCreator();

  const TNPData = useCustomSelector(
    (store) => store.procurements.tenderNoticePublicationState,
  );

  console.log("store hook tender notice", TNPData);

  useEffect(() => {
    fetchTNPDetails(id);
  }, [id]);

  return {
    TNPData,
    createTenderNoticePublication,
  };
};
